module.exports = __webpack_public_path__ + "site/img/index4.4cba05d0.png";